import css from 'styled-jsx/css'
import { colors } from './styles'
import SSPRegularWoff from './assets/fonts/sourcesanspro-regular.woff'
import SSPRegularWoff2 from './assets/fonts/sourcesanspro-regular.woff2'
import SSPSemiboldWoff from './assets/fonts/sourcesanspro-semibold.woff'
import SSPSemiboldWoff2 from './assets/fonts/sourcesanspro-semibold.woff2'
import SSPBoldWoff from './assets/fonts/sourcesanspro-bold.woff'
import SSPBoldWoff2 from './assets/fonts/sourcesanspro-bold.woff2'

const styles = css.global`
html, body {
  -webkit-font-smoothing: antialiased;
  font-family: 'Source Sans Pro', Tahoma, sans-serif;
  font-size: 16px;
  min-height: 100vh;
}

html, body, main, section, h1, h2, h3, h4, h5, h6, div, p {
  display: block;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: ${colors.primaryText};
}

ul, ol, li {
  box-sizing: border-box;
}

nav > ul, nav > li {
  list-style: none;
  margin: 0;
  padding: 0;
}

body {
  background: ${colors.baseBg};
  position: relative;
}

a, a:visited, a:active, a:hover {
  color: ${colors.primaryText};
  text-decoration: none;
}

span .super-class {
  font-size: 36px;
}

@font-face {
  font-family: 'Source Sans Pro';
  font-weight: 800;
  font-style: normal;
  font-display: swap;
  src:
    url(${SSPBoldWoff2}) format('woff2'),
    url(${SSPBoldWoff}) format('woff');
}

@font-face {
  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-style: normal;
  font-display: swap;
  src:
    url(${SSPSemiboldWoff2}) format('woff2'),
    url(${SSPSemiboldWoff}) format('woff');
}

@font-face {
  font-family: 'Source Sans Pro';
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  src:
    url(${SSPRegularWoff2}) format('woff2'),
    url(${SSPRegularWoff}) format('woff');
}

@media (max-width: 767px) {
  body.no-scroll {
    overflow: hidden !important;
  }
  span .super-class {
    font-size: 24px;
  }
}


.navlessLandingPage .PageHeader, .navlessLandingPage .PageFooter {
  display: none;
}


`
export default styles
